import { axiosApiService } from '../axios';

const GetTLFromLDAP = {
  fetchTL: async function (ldap) {
    const response = await axiosApiService.get(`search_tl_by_ldap/`, {
      params: { ldap },
    });
    return response.data;
  },
};

export default GetTLFromLDAP;
